import { useState, useCallback } from "react";
import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Categories } from "../components/site/Categories";
import { Shipping } from "../components/site/Shipping";
import { Manifesto } from "../components/site/Manifesto";
import { Contact } from "../components/site/Contact";
import { QuoteForm } from "../components/site/QuoteForm";

export default function Landing() {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [category, setCategory] = useState("");

  const openQuote = useCallback((cat = "") => {
    setCategory(typeof cat === "string" ? cat : "");
    setQuoteOpen(true);
  }, []);

  return (
    <div className="bg-background min-h-screen" data-testid="landing-page">
      <Navbar onQuote={() => openQuote()} />
      <main>
        <Hero onQuote={() => openQuote()} />
        <Marquee />
        <Categories onQuote={openQuote} />
        <Shipping onQuote={openQuote} />
        <Manifesto />
      </main>
      <Contact onQuote={openQuote} />
      <QuoteForm open={quoteOpen} onClose={() => setQuoteOpen(false)} initialCategory={category} />
    </div>
  );
}
